import Vue from 'vue';
import VueRouter, { RouterOptions, RouteRecord, Route } from 'vue-router';
// import idb from '@/services/indexedDb.service';
import { MswAppMain } from '@/core';
import { MswAppContent, MswAppContentOpenRoute } from '@/core/msw-app-content';
import { currentUserKey } from '@/shared/msw-constants';
import { SwFtrHelloSonicwallRoute } from '@/modules/sw-ftr-hello-sonicwall';
import { MswDpLoginRoute, MswForgotPasswordRoute, MswResetPasswordRoute, MswForgotUsernameRoute, getDefaultParams } from '@/core/msw-app-main/msw-dp-login';
import { MswProductsTabRoute, MswRegisterProductTabRoute, MswIPTapprove, MswITTapprove, MswMultiServiceActivationRoute, MSWGetMaintainanceKeyTabRoute } from '@/modules/msw-products';
import { MswCreateCustomerTabRoute } from '@/modules/msw-products/components/msw-create-customer';
import { MswUserGroupTabRoute } from '@/modules/msw-products/components/msw-user-group';
import { MswDashboardRoute } from '@/modules/msw-dashboard';
import { Renewalmanager } from '@/modules/msw-renewal-manager';
import { AvailableServices } from '@/modules/msw-available-services';
import { DownloadSignature } from '@/modules/msw-download-signature';
import MswMsspMonthlyPageRoute from '@/modules/msw-tenant-management/msw-tenant-management.route';
import { MswDownloadCenterRoute } from '@/modules/msw-download-center';
import ApiServiceWrapper from '@/shared/api-request.service';
import { HostedEmailSecurityRoute } from
  '@/modules/msw-products/components/msw-product-detail/todoComponents/hostedEmailSecurity';
import store from '@/store/store';
import { AppStore } from '@/store';
import { flexspendRoute, myFlexspendRoute } from '@/modules/msw-flexspend';
import { PSAIntegrationRoute } from '@/modules/psa-integration-connectwise';
import { MSWSpogHomepageRoute } from '@/modules/msw-spog-homepage';
import { Mytraining } from '@/modules/msw-training';
// @ts-ignore
import { activateService, useService } from '../../track/track.js';
import { MswSpogMain } from '@/core/msw-spog-main';
import { MswSpogLoginRoute } from '@/core/msw-spog-main/msw-dp-login';
import PrintProductDetails from '@/modules/msw-products/components/msw-product-detail/printProduct/printProduct.vue';
import { mswBuildcheckRoute } from '@/modules/msw-buildcheck';
import { UnifiedInsightRoute } from '@/modules/unified-insights';
import { DownloadCenterRoute } from '@/modules/download-center';
import { unifiedInsightsReportRoute } from '@/modules/unified-insights/unified-insights-reports';
import { MswUsageReportRoute } from '@/modules/msw-usage-report';
import { MswAccessMgmtRoute } from '@/modules/msw-accessmgmt';
import { OtherOperationsRoute } from '@/modules/msw-other-operations';
import { ActivityLogsRoute } from '@/modules/msw-activitylogs';
import { CatpProtectionRoute } from '@/modules/catp-protection';
import { SwAppMain } from '@/core/sw-app-main';
import { MswAtpTrainingRoute } from '@/modules/msw-atp-training';
import { MswIssueListRoute } from '@/modules/msw-issue-list';
import { MswLookupToolRoute } from '@/modules/msw-lookup-tool';
import { MswGuestOrMswLoginRoute } from '@/modules/msw-guestlogin-accountlogin';
import { MswManageCasesRoute, MswSupportCasesRoute } from '@/modules/msw-support-cases';
import { SubscriptionReportRoute, CloudReportsRoute } from '@/modules/msw-myreports';
import { MswPartnerResourceRoute } from '@/modules/msw-partner-resources';
import HelpContent from '@/core/msw-app-content/components/msw-help-content.vue';
import CatpProtection from '@/modules/catp-protection/catp-protection.component.vue';
import { NotificationCenterRoute } from '@/modules/msw-notification-center';
import { SandboxQuoteHistoryRoute, SandboxQuoteDetailsRoute } from '@/modules/msw-quotecomponent';
import SandboxPrintQuoteDetailRoute from '@/modules/msw-quotecomponent/quotehistory/quotedetails/printQuoteDetail.vue';
import { CatalogRouteModule, shoppingCartRouteModule } from '@/modules/msw-catalog';
import { CheckoutRoute } from '@/modules/msw-checkout';
import { MswProductClaimsRoute } from '@/modules/msw-product-claims';
import { MswMyToolsRoute, MswWifiPlannerRoute, MswSwarmReportRoute } from '@/modules/msw-tools';
// tslint:disable-next-line
import { sandboxPromotionsRoute,
         applySecureUpgrade,
         sandboxPromotionsHistoryRoute,
         sandboxApplicablePromotionsRoute,
         competitiveTradeIn,
         mswTransferServiceForSecureUpgradeRoute } from '@/modules/msw-promotions';
import { SandboxAutoRenewalRoute } from '@/modules/msw-auto-renewals';
import { SnbCoTermRoute, TermsOfServiceRoute } from '@/modules/msw-service-coterm';
import { mswOrdersPage } from '@/modules/msw-orders';
import mswOrderReciept from '@/modules/msw-orders/components/order-reciept.vue';
import { nfrServiceHistoryRoute, nfrServiceRoute } from '@/modules/msw-nfr-service';
import { SnbProfileRoute, SnbOrgProfileRoute } from '../modules/msw-profile';
import { FreeDownloadsRoute } from '@/modules/free-downloads';
import { RecaptchaV3TestRoute } from '@/modules/recaptchaV3-test';
import mswAccountService from '@/shared/msw-account-service/msw.account.service';
import { betaProgram } from '@/modules/msw-beta-program';
import { MswReportIssuesRoute, MswSignatureIssuesRoute } from '@/modules/msw-report-issues';
import { MswFreSoftwareTrailRoute } from '@/modules/msw-free-software-trials';
import { MswPrivacyRoute } from '@/core/msw-app-footer';
import PendoAnalyticsService from '@/shared/pendo-analytics.service';
import { MswPrefFileDownloadReportPrintRoute, MswPrefFileDownloadReportRoute } from '@/modules/msw-pref-file-download-report';
// import * as decode from 'jwt-decode';
const globalDefaultRouteName: string = 'globalDefault';
const storeT: AppStore = store;
// const prodUrl = 'cloud.sonicwall.com';
// const simUrl  = 'cloudbeta.sonicwall.com';
// const unifiedInsightRoutes =  (window.location.href.indexOf(prodUrl) > -1 ||
//                               window.location.href.indexOf(simUrl) > -1) ? [
//                                 { ...UnifiedInsightRoute },
//                               ] : [
//                                 { ...UnifiedInsightRoute },
//                                 { ...unifiedInsightsReportRoute },
//                               ];
const unifiedInsightRoutes = [
  { ...UnifiedInsightRoute },
  { ...unifiedInsightsReportRoute },
];

// const resetVueStore = () => {
//   storeT.dispatch('resetStore');
//   storeT.dispatch('DashBoardStoreModule/resetStore');
//   storeT.dispatch('MswProductsStoreModule/resetStore');
//   storeT.dispatch('DropdownStoreModule/resetStore');
// };

Vue.use(VueRouter);

// Seed isCustView into sessionStorage from the URL query param before the router
// guard runs. currentUserKey in msw-constants is evaluated at import time using
// sessionStorage, so this must execute before any auth check uses it.
(function seedCustViewFromQuery() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('isCustView') === 'YES') {
    sessionStorage.setItem('isCustView', 'YES');
  }
})();

const isByPassToken = (to: Route): boolean => {
  const tokenByPassListRoutes: string[] = ['/m/feature/catalog', '/m/feature/IptTransfer'];
  return tokenByPassListRoutes.includes(to.path.toString());
};

const router = new VueRouter(<RouterOptions>{
  mode: 'history',
  base: '/workspace/',
  routes: [
    {
      path: `${process.env.PUBLIC_PATH}m`,
      component: MswAppMain,
      children: [
        { ...MswDpLoginRoute, name: globalDefaultRouteName },
        {
          path: 'feature', component: MswAppContent, children: [
            { ...SwFtrHelloSonicwallRoute },
            { ...MswProductsTabRoute },
            { ...MswUserGroupTabRoute },
            { ...MswRegisterProductTabRoute },
            { ...MswIPTapprove },
            { ...MswITTapprove },
            { ...MswCreateCustomerTabRoute },
            { ...MSWGetMaintainanceKeyTabRoute },
            { ...MswDashboardRoute },
            { ...Renewalmanager },
            { ...DownloadSignature },
            { ...AvailableServices },
            { ...MswMsspMonthlyPageRoute },
            { ...DownloadCenterRoute },
            { ...PSAIntegrationRoute },
            // { ...UnifiedInsightRoute },
            // { ...unifiedInsightsReportRoute },
            { ...MSWSpogHomepageRoute },
            { ...Mytraining },
            { ...MswProductsTabRoute },
            { ...MswDownloadCenterRoute },
            { ...mswBuildcheckRoute },
            { ...HostedEmailSecurityRoute },
            { ...MswMultiServiceActivationRoute },
            { ...flexspendRoute },
            { ...myFlexspendRoute },
            { ...MswUsageReportRoute },
            { ...MswAccessMgmtRoute },
            { ...ActivityLogsRoute },
            { ...CatpProtectionRoute },
            { ...OtherOperationsRoute },
            { ...MswAtpTrainingRoute },
            { ...MswIssueListRoute },
            { ...MswLookupToolRoute },
            { ...SubscriptionReportRoute },
            { ...MswManageCasesRoute },
            { ...MswSupportCasesRoute },
            { ...MswPartnerResourceRoute },
            { ...NotificationCenterRoute },
            { ...SandboxQuoteHistoryRoute },
            { ...SandboxQuoteDetailsRoute },
            { ...CatalogRouteModule },
            { ...shoppingCartRouteModule },
            { ...CheckoutRoute },
            { ...MswProductClaimsRoute },
            { ...CloudReportsRoute },
            { ...sandboxPromotionsRoute },
            { ...applySecureUpgrade },
            { ...sandboxPromotionsHistoryRoute },
            { ...sandboxApplicablePromotionsRoute },
            { ...competitiveTradeIn },
            { ...mswTransferServiceForSecureUpgradeRoute },
            { ...SandboxAutoRenewalRoute },
            { ...SnbCoTermRoute },
            { ...TermsOfServiceRoute },
            { ...mswOrdersPage },
            { ...nfrServiceRoute },
            { ...nfrServiceHistoryRoute },
            { ...SnbProfileRoute },
            { ...SnbOrgProfileRoute },
            { ...FreeDownloadsRoute },
            { ...RecaptchaV3TestRoute },
            { ...betaProgram },
            { ...MswMyToolsRoute },
            { ...MswWifiPlannerRoute },
            { ...MswReportIssuesRoute },
            { ...MswSignatureIssuesRoute },
            { ...MswFreSoftwareTrailRoute },
            { ...MswPrivacyRoute },
            { ...MswSwarmReportRoute },
            { ...MswPrefFileDownloadReportRoute },
          ],
        },
        { ...MswGuestOrMswLoginRoute },
        {
          path:'help-content',
          component: HelpContent,
        },
        {
          path:'print-product',
          component: PrintProductDetails,
        },
        {
          path:'orderreceipt',
          component: mswOrderReciept,
        },
        { ...MswPrefFileDownloadReportPrintRoute },
      ],
      meta: { requiresAuth: true },
    },
    {
      path: `${process.env.PUBLIC_PATH}g`,
      component: MswAppContentOpenRoute,
      children: [
        { ...MswReportIssuesRoute },
        { ...MswSignatureIssuesRoute },
        { ...FreeDownloadsRoute },
        { ...CatalogRouteModule },
        { ...MswPrivacyRoute },
        { ...TermsOfServiceRoute },
        { ...MswForgotPasswordRoute },
        { ...MswResetPasswordRoute },
        { ...MswForgotUsernameRoute },
      ],
    },
    {
      path: `${process.env.PUBLIC_PATH}m/quoteReceipt`,
      component: SandboxPrintQuoteDetailRoute,
      meta : { requiresAuth: true },
    },
    {
      path: `${process.env.PUBLIC_PATH}User/CATPProtection`,
      component: CatpProtection,
      meta : { requiresAuth: true },
    },
    {
      path: `${process.env.PUBLIC_PATH}m/feature`,
      component: SwAppMain,
      children: unifiedInsightRoutes,
      meta : { requiresAuth: true },
    },
    {
      path: `${process.env.PUBLIC_PATH}muir/spog`,
      component: MswSpogMain,
      children: [
        { ...MswSpogLoginRoute, name: globalDefaultRouteName },
        { path: 'feature', component: MswAppContent, children: [
        { ...MSWSpogHomepageRoute },
        ]},
      ],
      meta : { requiresAuth: true },
    },
    {
      path: '/muir/login',
      redirect: { name: globalDefaultRouteName, params: getDefaultParams() },
    },
    {
      path: '/muir/resetpassword',
      redirect: { name: 'resetpassword', params: getDefaultParams() },
    },
    {
      /** for whatever unmatched routes */
      path: `${process.env.PUBLIC_PATH}*`,
      redirect: { name: globalDefaultRouteName, params: getDefaultParams() },
    },
  ],
});
router.beforeEach((to: Route, from: Route, next: any) => { // tslint:disable-line
  // @ts-ignore
  if (useService) {
    activateService(to, from);
  }
  Vue.nextTick(() => {
    storeT.dispatch('getBrowserTitles', { ...to });
  });
  try {
    // storeT.dispatch('getBrowserTitles', { ...to });
    const hideNavToggle: any = (to['query'].mode) as string;
    if (hideNavToggle === 'APP') {
      storeT.dispatch('toggleHideNavFunction', 'APP');
    }
  } catch (e) {
  }
  const currentUserT: any = localStorage.getItem(currentUserKey);
  // console.warn(`${JSON.parse(currentUserT).token}   ${typeof JSON.parse(currentUserT).token}`);
  let token = '';
  if (currentUserT && currentUserT !== 'null') {
    if (currentUserT!.indexOf('defaultApp') < 0) {
      const currentUser = JSON.parse(currentUserT);
      const res: any = {
        msgCode: '',
        msgDesc: '',
        content: {
          deviceCode: '',
          defaultApplication: 'MSW',
          sId: currentUser.sessionId,
          isFreeTrial: '',
          userName: currentUser.userId,
          emailAddress: currentUser.email,
          givenName: currentUser.displayName,
          token: currentUser.token,
          TFA: currentUser.tfa,
          roles: currentUser.roles,
          showRegisterPopup: currentUser.showRegisterPopup,
          showRememberMe: 'true',
          spogUser: currentUser.spogUser,
          refreshToken :  currentUser.refreshToken || '',
        },
      };
      storeT.dispatch('preserveUserInfo', res);
    }
    token = currentUserT && JSON.parse(currentUserT) ? JSON.parse(currentUserT).token : '';
    if (token !== '') {
      storeT.commit('mutate', { property: 'loggedIn', with: true });
    }
  } else {
    storeT.commit('mutate', { property: 'loggedIn', with: false });
  }
  // if (to.path.includes('/g')) {
  //   resetVueStore();
  //   localStorage.setItem(currentUserKey, '');
  //   localStorage.removeItem('supportCasesData');
  //   idb.clearData();
  // }
  if (to.matched.some((record:RouteRecord) => record.meta.requiresAuth)) {
    if ((to.path.includes('/m/login/login-view')) || (to.path.includes('/muir/spog/login'))) {
      console.warn('inside m/login/login-view condition');
      storeT.commit('mutate', { property: 'loggedIn', with: false });
      if ((to.path.includes('/m/login/login-view') || to.path.includes('/muir/spog/login') || to?.query?.spogUser?.toString() === 'true')) {
        mswAccountService.redirection(to, from, next);
      } else {
        next();
      }
    } else if (token !== '' || isByPassToken(to)) {
      const checkIfPendo: any = localStorage.getItem('showPendo') || '';
      console.warn(checkIfPendo);
      if (checkIfPendo === 'YES') {
        PendoAnalyticsService.startPendoAnalytics();
      }
      next();
    } else {
      if (window.top.location.href.indexOf('workspace/m/feature/spog-homepage') > -1) {
        const redirectUrl = btoa(window.top.location.href);
        window.top.location.href = `${window.top.location.origin}/muir/spog/login?REDIRECTPAGE=${redirectUrl}`;
      } else if (ApiServiceWrapper.$store.getters.getHideNavStatus === 'APP') {
        window.top.location.href = `${window.top.location.origin}/muir/login`;
      } else {
        const redirectPage: string = (window.location.href).replace(window.location.origin, '') || '';
        next({
          path: '/m/login/login-view',
          query: {
            ...(redirectPage && { redirectURL:  window.btoa(redirectPage) }),
          },
        });
      }
    }
  } else {
    next();
  }
});

export default router;
